// extracted by mini-css-extract-plugin
export default {"buttonPrimarySmall":"buttonPrimarySmall_buttonPrimarySmall__C0+N3","btnDisabled":"buttonPrimarySmall_btnDisabled__NQNT9"};